import Vue from 'vue'
import configs from '@/config'

// presenterUrl, not baseUrl: the grant cookie is host-only, so minting it anywhere else lands it on a
// host presenter never sends it to.
let resource = null
const backdoorPath = `${configs.presenterUrl}/api/users/backdoor/`

const actions = {
  start: {
    method: 'POST',
    url: backdoorPath,
    // The grant's Set-Cookie is cross-origin, so it needs credentials; enabling them globally would
    // also send them to non-API origins like the WordPress webhook.
    credentials: true,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const startBackdoor = async (userId) => {
  const res = await resource.start({}, { id: userId })
  return res.body
}

export default {
  initResource,
  startBackdoor,
}
